import { useUploadStatus } from "../../context/UploadStatusContext";

/**
 * Drop-in replacement for a form's submit button that disables itself while
 * an ImageUpload anywhere in the form is still uploading — prevents Save
 * from firing before an in-progress upload has updated the form's value.
 */
export default function SaveButton({ saving = false, className = "btn-pink w-full", children = "Save", ...rest }) {
    const { isUploading } = useUploadStatus();
    return (
        <button
            type="submit"
            disabled={saving || isUploading}
            className={`${className} disabled:opacity-60`}
            {...rest}
        >
            {isUploading ? "Waiting for upload to finish…" : saving ? "Saving…" : children}
        </button>
    );
}
